import * as React from 'react'

/**
 * @description Fence icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Fence } from '@sravni/design-system-icons'
 *
 * <Fence />
 * ```
 */
export const Fence = React.forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>((props, ref) => (
  <svg ref={ref} data-qa="Fence" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      clipPath="url(#Fence__a)"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M6.736 12h2M12.736 12h2M18.736 12h1M8.736 16.857V4.645c0-.33.1-.644.274-.861l1.207-1.505c.298-.372.74-.372 1.038 0l1.208 1.505c.173.217.273.53.273.86v12.213c0 .631-.358 1.143-.8 1.143h-2.4c-.441 0-.8-.512-.8-1.143v0ZM14.736 16.857V4.645c0-.33.1-.644.274-.861l1.207-1.505c.298-.372.74-.372 1.039 0l1.207 1.505c.173.217.273.53.273.86v12.213c0 .631-.358 1.143-.8 1.143h-2.4c-.441 0-.8-.512-.8-1.143v0ZM2.736 16.857V4.645c0-.33.1-.644.274-.861l1.207-1.505c.298-.372.74-.372 1.039 0l1.207 1.505c.173.216.273.53.273.86v12.213c0 .631-.358 1.143-.8 1.143h-2.4c-.441 0-.8-.512-.8-1.143ZM1.736 12h1" />
    </g>
    <defs>
      <clipPath id="Fence__a">
        <path fill="currentColor" transform="translate(.736)" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
))
